export const DEFAULT_SKELETON_ANIMATION_SPEED = 0.75;
